const SIP_DOMAIN_PATH = "domains";
const SIP_DOMAIN_DETAILS_PATH = "domains/:id";
const SIP_DOMAIN_NEW_PATH = "domains/new";
const SIP_IP_ACL_PATH = "ip-access-control-lists";

export const SIPPaths = {
    sipDomains: SIP_DOMAIN_PATH,
    sipDomainDetails: SIP_DOMAIN_DETAILS_PATH,
    sipDomainNew: SIP_DOMAIN_NEW_PATH,
    ipAccessControlLists: SIP_IP_ACL_PATH,
} as const satisfies Record<string, string>;
